export const navigationLinks = [
    {
      category: "Anydone",
      items: [ 
        { label: "Features", url: "https://www.anydone.com/ai-business-management-platform.html" },
        { label: "Pricing", url: "https://www.anydone.com/pricing.html" },
        { label: "Brand Assets", url: "https://www.anydone.com/brand-assets.html" },
        { label: "Download", url: "https://www.anydone.com/download-page-linux.html" },
        { label: "Security", url: "https://www.anydone.com/security.html" },
      ],
    },
    {
      category: "Product",
      items: [  
        { label: "Flowcess", url: "https://www.anydone.com/flowcess/business-process-automation.html" },
        { label: "AI Coworker", url: "https://www.anydone.com/ai-coworker.html" },
        { label: "Automated CRM", url: "https://www.anydone.com/automated-crm.html" },
        { label: "Business Messaging", url: "https://www.anydone.com/seamless-communication.html" },
        { label: "Project Management", url: "https://www.anydone.com/project-management.html" },
        { label: "Real Time Collaboration", url: "https://www.anydone.com/collab.html" },
        { label: "Roadmaps", url: "https://www.anydone.com/roadmap.html" },
        { label: "Assets", url: "https://www.anydone.com/assets.html" },
        { label: "Forms", url: "https://www.anydone.com/forms.html" },
        { label: "Papers", url: "https://www.anydone.com/papers.html" },
      ],
    },
    {
      category: "Company",
      items: [
        { label: "About Us", url: "https://www.anydone.com/about.html" },
        { label: "Blog", url: "https://blog.anydone.com/" },
        { label: "Career", url: "https://www.anydone.com/career.html" },
      ],
    },
    {
      category: "Help",
      items: [
        { label: "Contact Us", url: "https://www.anydone.com/contact.html" },
        { label: "Help Center", url: "https://help.anydone.com/" },
      ],
    },
  ];

export const socialLinks = [
    {
      name: "Anydone",
      url: "https://www.anydone.com/",
      icon: "/images/footer-anydone.svg",
      isTarget: true,
    },
    {
      name: "Twitter",
      url: "https://twitter.com/AnydoneUs?s=20",
      icon:"/images/twitter.svg",
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/anydone.us/",
      icon: "/images/facebook.svg",
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/anydone.us/",
      icon: "/images/instagram.svg",
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/anydone/",
      icon: "/images/linked_in.svg",
    },
    {
      name: "YouTube",
      url: "https://www.youtube.com/@anydone",
      icon: "/images/youtube.svg",
    },
  ];
  
export const footerLinks = [
    {
      type: "text",
      content: "© 2025 Anydone",
    },
    {
      type: "link",
      label: "Terms of Service",
      url: "https://www.anydone.com/terms.html",
    },
    {
      type: "link",
      label: "Privacy Policy",
      url: "https://www.anydone.com/privacy.html",
    },
    {
      type: "link",
      label: "Cookie Policy",
      url: "https://www.anydone.com/cookie.html",
    },
];

export const appDownloadLinks = [
    {
      name: "App Store",
      url: "https://apps.apple.com/np/app/anydone/id1601165191",
      icon: "/images/app-store.svg",
    },
    {
      name: "Google Play",
      url: "https://play.google.com/store/apps/details?id=com.anydone.inbox",
      icon: "/images/google-play.svg",
    },
  ];
  